import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ADRService, AdrTransportInput } from 'src/app/services/adr.service';
import { StepperService } from '../stepper.service';
import { ConfigService } from 'src/app/services/app.config.service';
import { AppConfig } from 'src/app/domain/appconfig';
import { debounce, debounceTime, Subscription } from 'rxjs';
import { DangerousGoods } from 'src/app/domain/DangerousGoods';
import { AbstractControl, FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Table, TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { DividerModule } from 'primeng/divider';
import { TranslateModule, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { Shipment } from 'src/app/domain/Shipment';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { OBPermisssionsLocal } from 'src/app/services/auth.service';
import { ClientService } from 'src/app/services/client.service';
import { SliderModule } from "primeng/slider";
import { InputSwitchModule } from "primeng/inputswitch";
import { CdkDragPlaceholder } from "@angular/cdk/drag-drop";

@Component({
  selector: 'app-dangerous-goods',
  templateUrl: './dangerous-goods.component.html',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    DropdownModule,
    FormsModule,
    ReactiveFormsModule,
    DividerModule,
    TranslateModule,
    InputTextModule,
    AutoCompleteModule,
    CheckboxModule,
    TooltipModule,
    ToggleButtonModule,
    CheckboxModule,
    SliderModule,
    InputSwitchModule,
  ],
  styleUrls: ['./dangerous-goods.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class DangerousGoodsComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('adrTable') table: Table;
  @Input("IsModal") IsModal: boolean;
  @Output("EventToCloseModal") EventToCloseModal = new EventEmitter<{ UpdateData: boolean }>();
  @ViewChild('autoCompleteObject', { read: ElementRef }) private autoCompleteObject: QueryList<ElementRef>;

  adrPermission = OBPermisssionsLocal.BookDangerousGoods;
  config: AppConfig;
  subscription: Subscription;
  shipment: Shipment;
  foundAdrs: DangerousGoods[] = [];
  UseAutoPointFunction = true;

  includeDangerousGoods: any;
  AdrOptions = new Array<DangerousGoods>();
  testCount = 0;
  adrConsent = false;
  isModal = false;
  UseAutoPointFunctionControll = new FormControl(true);

  ADRFormGroup = new FormGroup({
    ADRLines: new FormArray([])
  }, Validators.required)


  constructor(private configService: ConfigService, private adrService: ADRService, public stepperService: StepperService, private translateService: TranslateService, private clientService: ClientService) {
    this.config = this.configService.config;
    this.subscription = this.configService.configUpdate$.subscribe(
      (config) => { this.config = config; });

    this.shipment = this.stepperService.newShipment;

    if (this.shipment.dangerousGoods.length > 0)
      this.MapToFormControll();
    this.ADRFormGroup.statusChanges.subscribe(x => {
      if (x == "INVALID")
        this.stepperService.DisableNextStep();
      if (x == "VALID")
        this.stepperService.EnableNextStep();
    })
  }

  get GetADRFormControls() {
    return this.ADRFormGroup.controls.ADRLines as FormArray;
  }

  get CreateFormGroup() {
    this.testCount++;
    let tempFormgroup = new FormGroup({
      RowId: new FormControl(this.testCount),
      AdrCode: new FormControl(null, Validators.required),
      // ADRLiquneVolume: new FormControl(),
      ADRSoildVolume: new FormControl(),
      SelectedAdr: new FormControl(null, Validators.nullValidator),
      points: new FormControl(null),
      isAllowed: new FormControl(true),
      rejectReson: new FormControl(""),
      tunnelCode: new FormControl(""),
      AdrId: new FormControl(),
      lowQuantity: new FormControl(false)
    }, { validators: this.positiveVolumeValidator() })
    tempFormgroup.controls.AdrCode.valueChanges.subscribe(x => this.RecalclulateAdrPointAutoMagic(), debounceTime(30));
    return tempFormgroup;
  }

  ngOnInit(): void {
    if (this.shipment.dangerousGoods && this.shipment.dangerousGoods.length > 0) {
      this.includeDangerousGoods = true;
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    this.ADRFormGroup.statusChanges.subscribe(x => {
      this.shipment.dangerousGoods = [];
      if (x == "VALID" && this.GetADRFormControls.length > 0) {
        this.shipment.dangerousGoods = [];
        this.GetADRFormControls.controls.forEach(x => {
          let temp = x.get("SelectedAdr").value as DangerousGoods;
          this.shipment.dangerousGoods.push({
            class: temp.class,
            imdg: temp.imdg,
            // liquid: x.get('ADRLiquneVolume').value > 0,
            // liquidLiter:x.get('ADRLiquneVolume').value,
            netWeightKg: x.get('ADRSoildVolume').value,
            packageGroup: temp.packageGroup,
            unNumber: temp.unNumber,
            waybillString: temp.waybillString,
            packaging: temp.packaging,
            transportCategory: temp.transportCategory,
            environmental: temp.environmental,
            name: temp.name,
            TunnelCode: x.get("tunnelCode").value,
            grossWeightKg: x.get('ADRSoildVolume').value,
            point: x.get('points').value,
            lowQuantity: x.get('lowQuantity').value
          })
        })
        window.dispatchEvent(new CustomEvent("CheckPriceEvent", {}));
      }
    })
    // this.adrConsent = this.IsModal ?? false;
    this.isModal = this.IsModal ?? false;
  }

  waybillShortString(dangerousGood: any) {
    return dangerousGood.waybillString?.substring(0, 80);
  }

  adrSearch(event: any) {
    if (event.query == "UN" || event.query == "un") {
      this.foundAdrs = [];
      return;
    }
    if (event.query.includes('UN')) {
      event.query = event.query.replace('UN', '').trim();
    }
    if (event.query.includes('un')) {
      event.query = event.query.replace('un', '').trim();
    }

    this.adrService.searchADR(event.query).subscribe((data: any) => {
      if (data && data.items) {
        this.foundAdrs = data.items;
      }
    });
  }

  onRowEditCancel(line: FormGroup) {
    let controllIndex = this.GetADRFormControls.controls.findIndex(x => x.get('RowId').value == line.get('RowId').value);
    this.ADRFormGroup.controls.ADRLines.removeAt(controllIndex);
    this.table.cancelRowEdit(line);
  }

  GetLiquneTotalSum() {
    let sum = 0;
    // this.GetADRFormControls.controls.forEach(x => sum += x.get('ADRLiquneVolume').value);
    return sum
  }

  GetSolidTotalSum() {
    let sum = 0;
    this.GetADRFormControls.controls.forEach(x => sum += x.get('ADRSoildVolume').value);
    return sum
  }

  MapToFormControll() {
    this.shipment.dangerousGoods.forEach(adr => {
      let tempformGroup = this.CreateFormGroup;
      tempformGroup.get('AdrCode').setValue(adr.unNumber ?? "");
      tempformGroup.get('ADRSoildVolume').setValue(adr.grossWeightKg ?? 0);
      tempformGroup.controls.points.setValue(adr.point);
      tempformGroup.controls.lowQuantity.setValue(adr.lowQuantity);
      // tempformGroup.get('ADRLiquneVolume').setValue(adr.liquidLiter ?? 0);      
      tempformGroup.get('SelectedAdr').setValue({ class: adr.class, name: adr.name, waybillString: adr.waybillString, unNumber: adr.unNumber, tunnelCode: adr.TunnelCode,lowQuantity:adr.lowQuantity } as ADRObject);
      this.GetADRFormControls.push(tempformGroup);
    })
    if (this.shipment.dangerousGoods.length > 0)
      this.adrConsent = true;
  }

  /**
   * adds a new formgroup
   */
  AddADRLine() {
    this.testCount += 1;
    this.ADRFormGroup.controls.ADRLines.push(this.CreateFormGroup);
  }
  /**
   * assigns the un code to the line formgroup.
   */
  SetAdrCodeOnForm(event: ADRObject, formc: FormControl) {
    formc.get('AdrCode')?.setValue(event.unNumber);
    formc.get('SelectedAdr')?.setValue(event)
    formc.get("tunnelCode").setValue(event.tunnelCode);
    formc.get("AdrId").setValue(event.id);
  }

  CalcluLateAdrPoint(formcontroll: FormGroup) {
    if (this.UseAutoPointFunction && formcontroll.get("ADRSoildVolume").value > 0) {
      let tempAdr = { IsMixLoad: true, Amount: formcontroll.get('ADRSoildVolume').value, UNNo: formcontroll.get('AdrCode').value, ADRVersion: 2025, id: formcontroll.get('AdrId').value } as AdrTransportInput;
      this.adrService.AdrRuleCheckerFunc(tempAdr).subscribe(x => {
        formcontroll.get('points').setValue(x.item.points);
        formcontroll.get('isAllowed').setValue(x.item.isAllowed);
        formcontroll.get("rejectReson").setValue(x.item.reason);
      });
    }
  }
  /**
   * this loops throug all adr lines and sets points for the relevante adr lines
   * NOTE: this is only to be run when the user press the toggle btn there after it should only use CalcluLateAdrPoint
   * @param value value for togglebtn
   */
  UseAutoCalclulateFunction(value: boolean) {

    this.UseAutoPointFunction = value;
    if (value && this.GetADRFormControls != null) {
      this.GetADRFormControls.controls.forEach(c => {
        if (c.get('ADRSoildVolume').value > 0 && c.get('AdrCode').value > 0) {
          let tempAdr = { IsMixLoad: true, Amount: c.get('ADRSoildVolume').value, UNNo: c.get('AdrCode').value, ADRVersion: 2025 } as AdrTransportInput;
          this.adrService.AdrRuleCheckerFunc(tempAdr).subscribe(x => {
            c.get('points').setValue(x.item.points);
            c.get('isAllowed').setValue(x.item.isAllowed);
            c.get('rejectReson').setValue(x.item.reason);
          })
        }
      })
    } else {
      if (this.GetADRFormControls != null)
        this.GetADRFormControls.controls.forEach(x => {
          x.get('points').setValue(null);
          x.get('isAllowed').setValue(true);
          x.get('rejectReson').setValue("");
        })
    }
  }

  /**
   * this is a helper/wrapper
   */
  RecalclulateAdrPointAutoMagic() {
    this.UseAutoCalclulateFunction(this.UseAutoPointFunction);

  }

  GetPointTotalSum() {
    let totalSum = 0;
    this.GetADRFormControls.controls.forEach(x => {
      totalSum += x.get('points').value ?? 0;
    });
    return totalSum;
  }

  /**
   * 
   * @returns weather or not the sum of soild and liqune is over 0
   */
  positiveVolumeValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      // const liquid = group.get('ADRLiquneVolume')?.value || 0;
      const liquid = 0;
      const solid = group.get('ADRSoildVolume')?.value || 0;
      return (liquid + solid) > 0 ? null : { volumeInvalid: true };
    };
  }

  AdrAcerptToggle(value: any) {
    this.adrConsent = true;
  }

  OutputModal() {
    this.EventToCloseModal.emit({ UpdateData: true })

  }

  closeModal() {
    this.EventToCloseModal.emit({ UpdateData: false })
  }
  getTranslationNameFromReason(value: string, uNNo: string = "") {
    if (value.includes("Not allowed")) return this.translateService.instant("DANGEROUSGOODSPOINTREASONS.Not_allowed");
    else if (value.includes("Special limit")) return this.translateService.instant("DANGEROUSGOODSPOINTREASONS.Special_limit_one") + uNNo + this.translateService.instant("DANGEROUSGOODSPOINTREASONS.Special_limit_two");
    else if (value.includes("General allowed")) return this.translateService.instant("DANGEROUSGOODSPOINTREASONS.General_allowed");
    else if (value.includes("matched")) return this.translateService.instant("DANGEROUSGOODSPOINTREASONS.matched")
    return "";
  }

  CheckADrOnShipment(): void {
    if (this.shipment.dangerousGoods?.length > 0) {
      let adrService = this.clientService.clientServices.find(x => this.CheckForAdr(x.name));
      if (adrService) {
        let services = this.stepperService.newShipment.services ??= [];
        if (!services.includes(adrService.code))
          services.push(adrService.code);
      }
    }
    this.stepperService.stepNext();
  }


  CheckForAdr(s: string) {
    if ((s.toLowerCase() == "farliggods" || s.toLowerCase() == "farlig gods" || s.toLowerCase() == "adr" || s.toLowerCase() == "farligt gods") && this.shipment.dangerousGoods.length > 0)
      return true;
    else
      return false;
  }

}

interface ADRObject {
  class: string;
  imdg: null;
  name: string;
  packageGroup: string;
  packaging: string;
  transportCategory: string;
  tunnelCode: string;
  unNumber: string;
  waybillString: string;
  id: string;
  lowQuantity:boolean;
}